import Projectbox from './projectbox';
import "./css/projectgrid.css";
import { API_BASE_URL, authHeaders } from "../api";

function Projectgrid({ projects }) {

    const handleSourceClick = async (github) => {
        if (!github) return;

        const [user, repo] = github.split("/");

        try {
            const response = await fetch(
                `${API_BASE_URL}/api/download-repo/${user}/${repo}`,
                {
                    method: "GET",
                    headers: authHeaders()
                }
            );

            if (!response.ok) {
                throw new Error("Download failed");
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = `${repo}.zip`;
            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Download error:", error);
        }
    };

    return (
        <div className="projectgrid">
            {projects.map((project) => (
                <Projectbox
                    key={project.id}
                    title={project.title}
                    description={project.description}
                    github={project.github}
                    onSourceCodeClick={handleSourceClick}
                />
            ))}
        </div>
    );
}

export default Projectgrid;
